import Vue from 'vue';

import ElementUI from 'element-ui';
import router from './router';
import store from './store';
import 'element-ui/lib/theme-chalk/index.css';

import '@/assets/js/sfflex';
import '@/assets/css/reset.css';

Vue.config.productionTip = false;
Vue.use(ElementUI);

new Vue({
  router,
  store,
  template: '<router-view class="view" transition="fade" transition-mode="out-in"></router-view>',
}).$mount('#app');
